export default "__VITE_ASSET__CjIm0Q_a__"